import apiClient from '@/api'
import type { MePermissionsResponse } from '@/types/user'

export async function getMyPermissions(): Promise<MePermissionsResponse> {
  return apiClient.get<MePermissionsResponse>('/me/permissions')
}
